import React from "react";

import { CabinetCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function cabinet({ width, onResize }: Column.Options) {
	return base(ColumnId.Cabinet, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default cabinet;
